import React from 'react';
import { trackCaseStudyCTAClick } from '../../mixpanel/events';

const CaseStudyTakeaway = () => {
  const handleCTAClick = () => {
    trackCaseStudyCTAClick();
  };

  return (
    <section className="bg-white py-16">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Key Takeaway */}
        <div className="bg-apple-gray-100 border-l-4 border-apple-gray-400 p-8 mb-12 relative">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <svg className="w-8 h-8 text-apple-gray-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </div>
            <blockquote className="text-xl font-medium text-apple-gray-800 italic">
              "Sometimes you don't need to tweak a broken system — you need to replace it completely."
            </blockquote>
          </div>
        </div>

        {/* CTA */}
        <div>
          <h2 className="text-2xl font-bold text-apple-gray-800 mb-6">
            Want to streamline your delivery process too?
          </h2>
          <a
            href="https://form.typeform.com/to/SLoI0dkA"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCTAClick}
            className="inline-block bg-apple-gray-800 text-white font-semibold py-4 px-8 rounded-lg hover:bg-apple-gray-700 transition-colors duration-200"
          >
            Book a Strategy Call
          </a>
          <p className="text-sm text-apple-gray-600 mt-3">
            Free 30-min audit. No pitch. Just clarity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CaseStudyTakeaway;